define(function (require) {

    var _ = require('underscore');
    var Backbone = require('backbone');
    var AppConfig = require('config/application');

    var ModuleModel = Backbone.Model.extend({
        defaults: {
            enable: true
        }
    });

    var ModuleCollection = Backbone.Collection.extend({
        model: ModuleModel,
        comparator: function(model) {
            return model.get('type') == 'select' || model.get('type') == 'package';
        }
    });

    return Backbone.Model.extend({
        urlRoot: AppConfig.host + '/rest/tariffs/calculator?v=2',

        initialize: function() {
            this.set('modules', new ModuleCollection(this.get('modules') || []));
            this._bindModuleCollection();
            this._setTrafficEnabled();
        },

        parse: function(data) {
            if (data && data.modules) {
                this.get('modules').reset(data.modules);
                data.modules = this.get('modules');
                this._setTrafficEnabled();
            }
            return data;
        },

        _setTrafficEnabled: function() {
            var modulesCollection = this.get('modules');
            var analytics = modulesCollection.find({name: 'analytics'});

            if (analytics) {
                this._onChangeModuleValue(analytics, analytics.get('value'));
            }
        },

        _bindModuleCollection: function() {
            var modulesCollection = this.get('modules');

            if (modulesCollection instanceof  ModuleCollection) {
                this.listenTo(modulesCollection, 'change:value', this._onChangeModuleValue);
            }
        },

        _onChangeModuleValue: function(model, value) {
            var modulesCollection = this.get('modules');
            var trafficSlider = modulesCollection.find({name: 'traffic'});
            var trafficSliderValue = _.find(trafficSlider.get('values'), {id: trafficSlider.get('value')});
            var callSlider = modulesCollection.find({name: 'call'});
            var callSliderValue = _.find(callSlider.get('values'), {id: callSlider.get('value')});
            var traffic = app.Models.Account && app.Models.Account.get('traffic') || 0;
            var pbx = modulesCollection.find({name: 'pbx'});
            var parentPbx = false;

            if (model.get('name') == 'analytics' && !!value && (!trafficSliderValue || trafficSliderValue.value < traffic)) {
                trafficSlider.get('values').forEach(function(currentValue, index) {
                    if((!trafficSliderValue || trafficSliderValue.value < traffic) && +currentValue.value >= traffic) {
                        trafficSlider.set('value', currentValue.id);
                        trafficSliderValue = currentValue;
                    }
                });
            }

            if (model.get('name') == 'pbx' && !!value && (!callSliderValue || callSliderValue.value === 0)) {
                callSlider.set('value', (_.find(callSlider.get('values'), function(currentValue) {
                    return +currentValue.value > 0
                }) || {id:0}).id);
            }

            if (!pbx.get('value') && !!value) {
                parentPbx = (model.get('requires') || []).map(function(val) {
                    return val.reduce(function(acc, val) {
                        return acc || val == pbx.id;
                    }, false);
                }).reduce(function(acc, val) {
                    return acc || val;
                }, false);
                if (parentPbx) {
                    pbx.set('value', 1)
                }
            }

            this._toggleChildModules();
        },

        _toggleChildModules: function() {
            var modules = this.get('modules');
            var pbx = modules.find({name: 'pbx'});

            modules.each(function(module) {
                var requireModuleNames = [];
                var parenModuleIds = module.get('requires') || [];

                var moduleEnabled = parenModuleIds.map(function (val) {
                    var moduleNames = [];
                    var result = val.reduce(function (acc, val) {
                        var parentModule = modules.get(val);

                        moduleNames.push(parentModule.get('title'));
                        return acc && parentModule.get('value');
                    }, true);

                    requireModuleNames.push(moduleNames);
                    return result;
                }).reduce(function (acc, val) {
                    return acc || val;
                }, !parenModuleIds.length);

                var parentPbx = (module.get('requires') || []).map(function (val) {
                    return val.reduce(function (acc, val) {
                        return acc || val == pbx.id;
                    }, false);
                }).reduce(function (acc, val) {
                    return acc || val;
                }, false);

                if (!moduleEnabled) {
                    module.set('value', 0);
                }
                if (!parentPbx) {
                    module.set('enable', moduleEnabled);
                }
            });
        },

        toJSON: function() {
            var result = Backbone.Model.prototype.toJSON.call(this);

            if (result.modules instanceof ModuleCollection) {
                result.modules = result.modules.toJSON()
            }
            return result;
        },

        setDefaultValues: function() {
            var modules = this.get('modules');

            modules.each(function(module) {
                if(module.get('type') == 'checkbox') {
                    module.set('value', 1)
                }
                //
                //if ((module.get('type') == 'select' || module.get('type') == 'package') && module.get('name') != 'duration') {
                //    module.set('value', module.get('values')[0].id);
                //}
            });
        },

        getPrice: function() {
            var price = 0;
            var discountPrice = 0;
            var callPrice = 0;
            var smsPrice = 0;
            var modules = this.get('modules');
            var duration = modules.find({name: 'duration'});
            var allModulesEnabled = true;
            var activePackage;

            modules.each(function(module) {
                var count;

                if (module.get('type') == 'checkbox' && module.get('value')) {
                    price += module.get('price');
                }

                if (module.get('type') == 'number') {
                    count = module.get('value');
                    //if (count < 0) {
                    //    count = 0;
                    //}
                    price += module.get('price') * count;
                }

                if ((module.get('type') == 'select' || module.get('type') == 'package') && module.get('value')) {
                    if (module.get('name') == 'duration') {
                        activePackage = _.find(module.get('values'), {id: module.get('value')});
                        if (activePackage && activePackage.value < 0) {
                            discountPrice = activePackage.price;
                        }
                    } else if (module.get('name') == 'sms') {
                        smsPrice = _.find(module.get('values'), {id: module.get('value')}).price;
                    } else if (module.get('name') == 'call') {
                        callPrice = _.find(module.get('values'), {id: module.get('value')}).price;
                    } else {
                        price += _.find(module.get('values'), {id: module.get('value')}).price;
                    }
                }

                if ((module.get('type') == 'checkbox' && !module.get('value')) ||
                    (module.get('type') == 'offer' && !module.get('value')) ||
                    ((module.get('type') == 'select' || module.get('type') == 'package') && module.get('name') != 'duration' && module.get('name') != 'sms' && module.get('name') != 'call' && module.get('value') != module.get('values')[0].id)) {
                    allModulesEnabled = false;
                }
            });

            return {
                price            : price,
                discountPrice    : discountPrice,
                smsPrice         : smsPrice,
                callPrice        : callPrice,
                allModulesEnabled: allModulesEnabled,
                activePackage    : activePackage
            }
        },

        check: function() {
            var that = this;
            var def = new $.Deferred();

            return Backbone.ajax({
                url: AppConfig.host + '/tariffs/calculator/verification',
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(this.toJSON())
            }).then(function(response){
                that.get('modules').reset(response.modules);
                response.modules = that.get('modules');
                that.set(response);
                def.resolve();
            });

            return def
        }
    });
});